<template>
    <div class="HotWaterTableHeader">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 83px)">
                <DxDataGrid ref="HotWaterTableHeaderList"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @init-new-row="onInitNewRow"
                            @row-prepared="onRowPrepared"
                            @cell-prepared="onCellPrepared"
                            @row-click="onRowClick"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-deleting="true"
                               :use-icons="true" />

                    <DxPaging :page-size="20" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="true" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="hasError"
                              caption=""
                              :allowEditing="false"
                              :allowSorting="false"
                              data-type="boolean"
                              width="36"
                              alignment="center"
                              cell-template="validColumnTemplate"
                              header-cell-template="validColumnHeader" />
                    <DxColumn data-field="filename"
                              caption="Fájlnév"
                              header-cell-template="title-header" />
                    <DxColumn data-field="size"
                              caption="Fájl mérete"
                              header-cell-template="title-header" />
                    <DxColumn data-field="issueDate"
                              caption="Hónap"
                              :customize-text="monthFormat"
                              header-cell-template="title-header"
                              alignment="left"
                              data-type="datetime" />
                    <DxColumn data-field="createdBy"
                              caption="Feltöltő"
                              header-cell-template="title-header" />
                    <DxColumn data-field="createdDate"
                              caption="Feltöltés dátuma"
                              :customize-text="dateFormat"
                              header-cell-template="title-header"
                              alignment="right"
                              data-type="datetime" />
                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton name="edit"
                                  hint="Szerkesztés"
                                  icon="background"
                                  :visible="false" />
                        <DxButton name="save"
                                  hint="Mentés"
                                  icon="check" />
                        <DxButton name="cancel"
                                  hint="Mégsem"
                                  icon="close" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #validColumnTemplate="{ data: cellInfo }">
                        <div v-if="cellInfo.data.hasError"
                             class="warning-icon-holder">
                            <i class="dx-icon-warning warning-icon" title="A feltöltött fájl hibákat tartalmaz!"></i>
                        </div>
                    </template>

                    <template #validColumnHeader="{ data }">
                        <i class="dx-icon-warning warning-icon-header"></i>
                    </template>

                    <template #summarize="{ data }">
                        <div>
                            <DxBtn name="sumdata"
                                   hint="Összesített adatok"
                                   text="Összesített adatok"
                                   icon="chart"
                                   @click="summarizeData" />
                        </div>
                    </template>

                    <template #meterReplaceList="{ data }">
                        <div>
                            <DxBtn name="meterReplaceList"
                                   hint="Lecserélt mérőórák"
                                   text="Lecserélt mérőórák"
                                   icon="orderedlist"
                                   @click="meterReplaceList" />
                        </div>
                    </template>

                    <template #uploadFile="{ data }">
                        <div>
                            <DxBtn name="upload"
                                   hint="Fájl feltöltés"
                                   text="Fájl feltöltés"
                                   icon="upload"
                                   @click="openPopup" />
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>

        <DxPopup width="400"
                 :height="350"
                 :show-title="true"
                 title="Melegvíz leolvasás adatok feltöltése"
                 :drag-enabled="false"
                 :close-on-outside-click="true"
                 :show-close-buttton="true"
                 :onInitialized="onPopupInit">

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="uploadBtn" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="closeBtn" />

            <template #content="{ data }">
                <div style="width:100%">
                    <div class="form-input">
                        <label>Leolvasás adatok</label>
                        <form>
                            <DxFileUploader select-button-text="Válassza ki a fájlt"
                                            ref="fileupload"
                                            label-text=""
                                            accept="text/xml"
                                            upload-mode="useForm" />
                        </form>
                    </div>
                    <div class="form-input">
                        <label>Elszámolási időszak (hónap)</label>
                        <DxDateBox v-model:value="selectedMonth"
                                   type="date"
                                   display-format="monthAndYear">

                            <DxCalendarOptions min-zoom-level="century"
                                               max-zoom-level="year" />
                        </DxDateBox>
                    </div>
                </div>
            </template>
        </DxPopup>

    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import HotWaterTableHeaderService from "../services/HotWaterTableHeader.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';
    import DxDateBox, { DxCalendarOptions } from 'devextreme-vue/date-box';
    import moment from 'moment';
    import { DxFileUploader } from 'devextreme-vue/file-uploader';

    export default {
        name: 'HotWaterTableHeader',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxLoadPanel,
            DxDateBox,
            DxCalendarOptions,
            DxFileUploader
        },
        data() {
            return {
                datagrid: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => HotWaterTableHeaderService.get(),
                    insert: (values) => {
                        return HotWaterTableHeaderService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        HotWaterTableHeaderService.update({
                            key: key,
                            values: JSON.stringify(values)
                        }),
                    remove: key => HotWaterTableHeaderService.delete(key)
                }),
                selectedMonth: moment().subtract(1, 'months'),
                closeBtn: {
                    icon: 'close',
                    text: 'Mégsem',
                    onClick: () => this.popup.hide()
                },
                uploadBtn: {
                    icon: 'upload',
                    text: 'Feltöltés',
                    onClick: () => this.importFile()
                }
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
            },
            onInitNewRow(e) {
                new Promise(resolve => setTimeout(resolve, 10)).then(() => {
                    e.component.saveEditData();
                    e.component.deselectAll();
                });
            },
            onRowClick(e) {
                if (e.rowType === "data") {
                    this.$router.push({ path: `/hotwatertable/${e.key}` })
                }
            },
            onRowPrepared(e) {
                if (e.component.getVisibleRows()[e.rowIndex] &&
                    e.component.getVisibleRows()[e.rowIndex].isNewRow &&
                    e.rowType == 'data')
                    e.rowElement.classList.add('d-none');

                if (e.rowType === "data") {
                    if (e.data.hasError) {
                        e.rowElement.classList.add('error-row');
                    }
                    if (e.data.hasWarning) {
                        e.rowElement.classList.add('warning-row');
                    }
                }
            },
            onCellPrepared(e) {
                if (e.rowType === "filter" && e.column.dataField === "hasError") {
                    e.cellElement.innerHTML = "";
                    let element = document.createElement("div");
                    e.cellElement.appendChild(element);
                    // TODO: Itt meg kell oldani a szűrhetőséget a hibás sorokra!
                    //console.log(e);
                }
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: 'uploadFile'
                });

                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'summarize'
                });

                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'meterReplaceList'
                });
            },
            meterReplaceList() {
                this.$router.push('/meterreplacelist');
            },
            summarizeData() {
                this.$router.push('/hotwatertablesummarized');
            },
            openPopup() {
                if (this.popup) {
                    this.popup.show();
                }
            },
            onPopupInit(e) {
                this.popup = e.component;
            },
            importFile() {
                var fileExtension = ['xml', 'xls', 'xlsx'];
                var filename = this.$refs.fileupload.instance._files[0].value.name;

                if (filename.length == 0) {
                    notify({
                        message: 'Válasszon ki egy excel fájlt!',
                        position: {
                            at: "top",
                            offset: "0 40"
                        }
                    }, "error", 5000);
                    return false;
                }
                else {
                    var extension = filename.replace(/^.*\./, '');
                    if (!fileExtension.includes(extension)) {
                        notify({
                            message: 'A fájl típusa nem megfelelő!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "error", 5000);
                        return false;
                    }
                }

                var fdata = new FormData();
                fdata.append('issueMonth', moment(this.selectedMonth).format('YYYY-MM-DD'));

                var fileUpload = this.$refs.fileupload.instance;
                var files = fileUpload._files;
                fdata.append(files[0].value.name, files[0].value);

                this.popup.hide();
                this.datagrid.beginCustomLoading('Fájl feltöltése folyamatban...');
                let that = this;

                HotWaterTableHeaderService.import(fdata)
                    .then(result => {
                        this.datagrid.endCustomLoading();
                        this.datagrid.refresh();

                        notify({
                            message: 'Az importálás sikeresen befejeződött!',
                            position: {
                                at: "top",
                                offset: "0 40"
                            }
                        }, "success", 5000);
                    });
            },
            dateFormat(cellInfo) {
                var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            },
            monthFormat(cellInfo) {
                var options = { year: 'numeric', month: 'long' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }

    ::v-deep .grid {
        fill-opacity: 0;
    }

    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        padding: 3px 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }

    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }

    ::v-deep .dx-row-lines:hover > td {
        background: #c6e3fb;
        cursor: pointer;
    }

    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }

    ::v-deep .dx-row-lines:hover {
        background-color: #c6e3fb !important;
        cursor: pointer;
    }

    ::v-deep .dx-row-lines.warning-row:hover {
        background-color: #ffe5a4 !important;
        cursor: pointer;
    }

    ::v-deep .warning-row {
        background-color: #f9f2b1 !important;
        border-color: #f9f2b1 !important;
    }

    ::v-deep .dx-row-lines.error-row:hover {
        background-color: #ff9292 !important;
        cursor: pointer;
    }

    ::v-deep .error-row {
        background-color: #ffa1a1 !important;
        border-color: #ffa1a1 !important;
    }

    ::v-deep .dx-fileuploader-files-container {
        padding-top: 0 !important;
        height: 65px;
    }

    ::v-deep .dx-form-group-caption {
        font-size: 16px;
    }

    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }

    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
</style>